"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LinkButton = _styledComponents.default.button.attrs(function (_ref) {
  var type = _ref.type;
  return {
    type: type || 'button'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  color: #ffc033;\n  width: auto;\n  text-transform: uppercase;\n  padding: 0 10px;\n  letter-spacing: 0.05em;\n  font-family: 'Gentleman', Arial, sans-serif;\n  font-weight: 800;\n  font-size: 13px;\n  font-style: normal;\n  height: 32px;\n  display: block;\n  background: transparent;\n  cursor: pointer;\n  &:hover {\n    color: #c9982a;\n  }\n  &:disabled {\n    color: #6c757d;\n    cursor: not-allowed;\n  }\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n  ", "\n"])), function (_ref2) {
  var $bsStyle = _ref2.$bsStyle;
  return $bsStyle || '';
});
exports.LinkButton = LinkButton;